import React from 'react';
import PerksList from 'ui/PerksList/PerksList';

const Perks = ({title, perks}) => (
    <div className="container">
        <h2 className="text-center leading">{title}</h2>
        <PerksList perks={perks} />
    </div>
);

export default Perks;
